import './cfl-ms-25-characters.swiper.js';

// Tabs show/hide logic for CFL MS 25 Characters
// Swiper logic is separated in cfl-ms-25-characters.swiper.js

// Swiper module is split into cfl-ms-25-characters.swiper.js

window.addEventListener("load", function () {
    const navItems = document.querySelectorAll('.js_nav li');
    const charItems = document.querySelectorAll('.js_item');
    const prevBtn = document.querySelector('.character-prev');
    const nextBtn = document.querySelector('.character-next');
    //const audioElements = document.querySelectorAll('.audios');

    function setActiveCharacter(index) {
        // Guard against empty node lists or invalid index
        if (!charItems || !charItems.length) return;
        var safeIndex = Math.max(0, Math.min(index, charItems.length - 1));

        // 1) Sync nav active state
        navItems.forEach(item => item.classList.remove('active'));
        if (navItems[safeIndex]) navItems[safeIndex].classList.add('active');

        // 2) Switch character panels
        charItems.forEach(item => {
            item.classList.remove('act');
            item.style.display = 'none';
        });
        charItems[safeIndex].classList.add('act');
        charItems[safeIndex].style.display = 'block';
        // Thêm: Load hình ảnh trong tab active để cải thiện lazy loading
        const images = charItems[safeIndex].querySelectorAll('img[data-src]');
        images.forEach(img => {
            if (!img.src) { // Chỉ load nếu chưa có src
                img.src = img.dataset.src;
                img.classList.remove('MJ__lazyload'); // Loại bỏ class để tránh conflict với script lazy load tùy chỉnh
            }
        });
    }

    navItems.forEach((nav, index) => {
        nav.addEventListener('click', function() {
            setActiveCharacter(index);
        });
    });

    function getCurrentActiveIndex() {
        var currentIndex = -1;
        charItems.forEach((item, i) => {
            if (currentIndex !== -1) return;
            if (item.classList.contains('act')) currentIndex = i;
        });
        return currentIndex === -1 ? 0 : currentIndex;
    }

    // Prev / Next controls (mobile button style in template)
    if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
            e.preventDefault();
            var currentIndex = getCurrentActiveIndex();
            var targetIndex = currentIndex - 1;
            if (targetIndex < 0) targetIndex = charItems.length - 1;
            setActiveCharacter(targetIndex);
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
            e.preventDefault();
            var currentIndex = getCurrentActiveIndex();
            var targetIndex = currentIndex + 1;
            if (targetIndex > charItems.length - 1) targetIndex = 0;
            setActiveCharacter(targetIndex);
        });
    }

    // Khởi tạo tab đầu tiên khi load trang: load ảnh và trigger animation
    setActiveCharacter(0);

    // Xử lý click vào nút Sound (Voice nhân vật)
    // const soundButtons = document.querySelectorAll('.sounds');
    // soundButtons.forEach(btn => {
    //     btn.addEventListener('click', function(e) {
    //         e.preventDefault();
    //         const audioId = this.getAttribute('data-id');
    //         const targetAudio = document.getElementById(audioId);

    //         if (targetAudio) {
    //             if (targetAudio.paused) {
    //                 stopAllAudio();
    //                 targetAudio.play();
    //             } else {
    //                 targetAudio.pause();
    //             }
    //         }
    //     });
    // });
});

